export default __webpack_public_path__ + "static/N0207-aa6eaea37b208acdc289deb867bafbbd.png";